import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import ActionModal from './ActionModal'
import { SettingsList } from 'portal-modules/common/components/settings-list'
import SystemMessage from 'portal-modules/common/components/SystemMessage'

const SettingsModal = props => {
  const [checkedValue, setCheckedVlaue] = useState(props.initialValue || [])

  const handleSubmit = () => {
    const { items, settingsKey } = props
    const inverseValues = items
    ?.map(({ id }) => id)
    ?.filter(id => !checkedValue.includes(id))
    props.onSubmit({ [settingsKey]: inverseValues })
    props.onClose()
  }

  const handleUpdatedSettings = ({ type, value }) => {
    if (type === 'ON_CHANGE') {
      setCheckedVlaue(value)
    }
  }

  const {
    initialValue,
    items,
    onSubmit,
    settingsKey,
    minRequired,
    defaultKey,
    defaultMsg,
    buttonLabel,
    ...modalProps
  } = props

  return (
    <ActionModal
      {...modalProps}
      onCancel={() => setCheckedVlaue(props.initialValue)}
    >
      {() => (
        <Fragment>
          <SettingsList
            onUpdate={handleUpdatedSettings}
            value={checkedValue}
            name={settingsKey}
          >
            {items?.map(item => (
              <SettingsList.Item key={item.id} {...item} />
            ))}
          </SettingsList>
          {'' != defaultMsg &&
            undefined != defaultKey &&
            0 != defaultKey &&
            !checkedValue.includes(defaultKey.toString()) && (
              <SystemMessage type='error'>{defaultMsg}</SystemMessage>
            )}
          <Button
            style={{
              width: '100%',
              'margin-bottom': '10px',
            }}
            disabled={
              (minRequired && !(minRequired <= checkedValue.length)) ||
              (0 != defaultKey &&
                undefined != defaultKey &&
                !checkedValue.includes(defaultKey.toString()))
            }
            appearance='primary'
            onClick={handleSubmit}
            size='large'
          >
            {buttonLabel}
          </Button>
        </Fragment>
      )}
    </ActionModal>
  )
}

SettingsModal.propTypes = {
  /** Starting values for the form. Usually an array of item ids. */
  initialValue: PropTypes.arrayOf(PropTypes.string),
  /** Array of settings items */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ).isRequired,
  /** Hook to the action modal cancel event when needed */
  onCancel: PropTypes.func,
  /** Toggle modal visibility. Usually provided by ModalControl */
  onClose: PropTypes.func.isRequired,
  /** Hook to the submit event of the settings form */
  onSubmit: PropTypes.func.isRequired,
  /** The key name where settings are saved */
  settingsKey: PropTypes.string.isRequired,
  /** Toggle visibility of the modal. Usually provided by ModalControl */
  show: PropTypes.bool,
  /** The title for the settings action modal */
  title: PropTypes.string,
  /** Escape hatch when needing to make minor additions/adjustments to the container div for the action modal */
  wrapperClass: PropTypes.string,
  /** It will enforce at least minRequired number of options selection to enable action button */
  minRequired: PropTypes.number,
  defaultKey: PropTypes.number,
  defaultMsg: PropTypes.string,
  buttonLabel: PropTypes.string,
}

SettingsModal.defaultProps = {
  title: __('Manage Settings'),
  defaultMsg: '',
  defaultKey: 0,
  buttonLabel: __('Save'),
}

export default SettingsModal
